/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Deals_Empty_TitleInputs */

const en_directory_hubs_deals_empty_title = /** @type {(inputs: Directory_Hubs_Deals_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No active deals yet`)
};

const zh_directory_hubs_deals_empty_title = /** @type {(inputs: Directory_Hubs_Deals_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无有效优惠`)
};

/**
* | output |
* | --- |
* | "No active deals yet" |
*
* @param {Directory_Hubs_Deals_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_deals_empty_title = /** @type {((inputs?: Directory_Hubs_Deals_Empty_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Deals_Empty_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_deals_empty_title(inputs)
	return zh_directory_hubs_deals_empty_title(inputs)
});
export { directory_hubs_deals_empty_title as "directory.hubs.deals.empty_title" }